export default __webpack_public_path__ + "static/media/banner.67c9ccc2.jpg";